import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const BillAndCoinsIcon = ({
  width = 55,
  color = 'petroleumGreen',
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 55 48">
      <g fill="none" fillRule="evenodd">
        <g fill={getSemanticTextColor(color)}>
          <g>
            <g>
              <path
                d="M30.708 36.03c3.283 0 5.945 2.678 5.945 5.985 0 3.306-2.662 5.985-5.945 5.985-3.282 0-5.944-2.679-5.944-5.985 0-3.307 2.662-5.985 5.944-5.985zM3.958 22.599c.631.188 1.297.291 1.984.291v13.896h20.053c-.62.567-1.14 1.241-1.527 1.998H3.958zm40.92 10.471c.598.447 1.264.803 1.986 1.041v4.673h-9.915c-.388-.755-.907-1.431-1.527-1.998h9.456zM43.8 18.996v3.722c-1.096 1.25-1.77 2.884-1.77 4.678 0 1.795.674 3.43 1.77 4.678V35.7h-9.947c-.947-.48-2.014-.757-3.145-.757-1.13 0-2.198.277-3.144.757H7.024V22.797c2.271-.354 4.183-1.805 5.186-3.8H43.8zm5.254 2.415c3.283 0 5.945 2.679 5.945 5.985 0 3.307-2.662 5.985-5.945 5.985-3.282 0-5.946-2.678-5.946-5.985 0-3.306 2.664-5.985 5.946-5.985zm-23.642.321c-3.137 0-5.68 2.56-5.68 5.72 0 3.158 2.543 5.717 5.68 5.717 3.137 0 5.678-2.559 5.678-5.717 0-3.16-2.541-5.72-5.678-5.72zM5.946 9.834c3.283 0 5.943 2.678 5.943 5.985 0 3.306-2.66 5.985-5.943 5.985C2.662 21.804 0 19.125 0 15.82c0-3.307 2.662-5.985 5.946-5.985zm40.918 6.078v4.77c-.722.238-1.388.595-1.986 1.042V17.91H12.654c.194-.633.3-1.305.31-2h33.9zM19.608 0c3.283 0 5.945 2.679 5.945 5.985 0 3.307-2.662 5.985-5.945 5.985-3.284 0-5.946-2.678-5.946-5.985C13.662 2.68 16.324 0 19.608 0z"
                transform="translate(-20 -1513) translate(20 1510) translate(0 3)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  </DefaultIconWrapper>
);
